import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { environment } from '../../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class WizardService {
    private readonly httpService = inject(HttpService);

    yeasList(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/years`, data);
    }

    groupList(data: any,role:any='member'): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/${role}/all/groups`, data);
    }

    annualOutcomesList(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/outcomes/list`, data);
    }

    annualOutcomesDropdown(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/outcomes/list/dropdown`, data);
    }
    groupMembers(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/group/members`, data);
    }

    createBacklogs(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/backlogs/create`, data);
    }

    createMilestonesData(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/milestones/create`, data);
    }

    createOutcomesData(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/backlogs/transform`, data);
    }

    backlogListByOutcome(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/backlogs/list/by/outcome`, data);
    }

    startOver(data: any): Observable<any> {
        return this.httpService.post(`${environment.opbBackendHost}/api/member/outcomes/start/over`, data);
    }

}